/**
 * Validates gift-customizer fields (title, description, ribbon, gift tag).
 * Returns true when valid or when the gift customizer is not on the page.
 */
function validateGiftCustomizer() {
  const configEl = document.getElementById('gift-customizer-config');
  if (!configEl) return true;

  const fields = {
    title: configEl.dataset.fieldTitle,
    description: configEl.dataset.fieldDescription,
    ribbonColor: configEl.dataset.fieldRibbonColor,
    ribbonText: configEl.dataset.fieldRibbonText,
  };

  let valid = true;
  let firstErrorHeading = null;

  document.querySelectorAll('.product-form__error-message-wrapper[data-field]').forEach((el) => {
    el.setAttribute('hidden', '');
  });

  function showFieldError(fieldKey, headingSelector) {
    valid = false;
    const wrapper = document.querySelector(
      `.product-form__error-message-wrapper[data-field="${CSS.escape(fieldKey)}"]`
    );
    if (wrapper) wrapper.removeAttribute('hidden');
    if (!firstErrorHeading) {
      firstErrorHeading = document.querySelector(headingSelector);
    }
  }

  const titleInput = document.querySelector('input.gift-message-input[name="properties[GiftTitle]"]');
  if (titleInput && !titleInput.value.trim()) {
    showFieldError(fields.title, 'h4.gift-message-heading');
  }

  const descInput = document.querySelector('textarea.gift-message-input[name="properties[GiftDescription]"]');
  if (descInput && !descInput.value.trim()) {
    showFieldError(fields.description, 'h4.gift-message-heading');
  }

  const ribbonChecked = document.querySelector(
    'input.gift-message-input[name="properties[GiftRibbonColor]"]:checked'
  );
  if (!ribbonChecked) {
    showFieldError(fields.ribbonColor, 'h4.gift-message-heading:last-of-type');
  } else if (ribbonChecked.dataset.giftTagEditable === 'true') {
    const tagInput = document.querySelector(
      '.ribbon-text-customizer-modal input.gift-message-input[name="properties[GiftRibbonGiftTag]"]'
    );
    if (tagInput && !tagInput.value.trim()) {
      showFieldError(fields.ribbonText, 'h4.gift-message-heading:last-of-type');
    }
  }

  if (!valid && firstErrorHeading) {
    const top = firstErrorHeading.getBoundingClientRect().top + window.scrollY - 120;
    window.scrollTo({ top, behavior: 'smooth' });
  }

  return valid;
}

window.validateGiftCustomizer = validateGiftCustomizer;
